import collegeVisitCompanionData from './college-visit-companion-content.json';
import collegeVisitGuideData from './college-visit-guide-content.json';
import type { CollegeVisitContent, CollegeVisitCompanionContent } from './types';

export * from './types';

export const collegeVisitGuideContent = collegeVisitGuideData as CollegeVisitContent;
export const collegeVisitCompanionContent =
  collegeVisitCompanionData as CollegeVisitCompanionContent;
export * from './proTipImages';
